import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { StateTermsFields, useCompliance, complianceReady } from "../components/StateTermsFields";

export default function FinishJoinPage() {
  const { state: pending } = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const compliance = useCompliance();
  const [legal, setLegal] = useState({ state: "", age_confirmed: false, accept_terms: false, intermediary_ack: false });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (!pending?.pending_id) return <Navigate to="/register" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/google/finish", { pending_id: pending.pending_id, ...legal, referral_code: localStorage.getItem("vq_ref") || undefined });
      setUser(data.user);
      toast.success("Account created — claim your spot");
      nav("/dashboard", { replace: true });
    } catch (e2) { setErr(formatApiError(e2)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center px-6 md:px-16 pt-28 pb-16">
      <form onSubmit={submit} data-testid="finish-join-form" className="w-full max-w-md space-y-6 rise">
        <p className="eyebrow">Almost there</p>
        <h1 className="font-serif-lux text-4xl sm:text-5xl">Finish joining</h1>
        <p className="text-sm text-slate-400">Signed in with Google as <span data-testid="finish-join-email" className="text-slate-200">{pending.email}</span>. Confirm a few things to create your account.</p>
        <StateTermsFields value={legal} onChange={setLegal} compliance={compliance} />
        {err && <p data-testid="finish-join-error" className="text-sm text-red-400">{err}</p>}
        <button data-testid="finish-join-submit-btn" disabled={busy || !complianceReady(legal, compliance)} className="btn-gold w-full py-3.5">
          {busy ? "Please wait…" : "Create account"}
        </button>
      </form>
    </div>
  );
}
